import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Conduite dangereuse et alcool au volant - Quelles sanctions?"
            description="Nous vous expliquons les infractions criminelles de conduite dangereuse et de conduite avec facultés affaiblies par l’, ainsi que les sanctions qui en découlent!"
            fr={undefined}
            lawType="criminal"
            specialtyText="pour Conduite dangereuse et alcool au volant">
            <p>
                La conduite dangereuse et la conduite avec les facultés
                affaiblies sont deux infractions distinctes. Bien que vous
                puissiez être coupable des deux infractions pour le même
                événement, les conséquences seront distinctes.
            </p>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Qu’est-ce que l’infraction criminelle de conduite dangereuse ?"
                    alt=""
                />
            </p>
            <p>
                Dans les deux infractions, vous pouvez vous attendre aux
                conséquences suivantes: peine d’emprisonnement, interdiction de
                conduire, révocation du permis de conduire, contravention et
                casier judiciaire.
            </p>
            <p>
                <strong>
                    Dans cet article, nous vous expliquerons les infractions de
                    conduite dangereuse et de conduite avec les facultés
                    affaiblies ainsi que leurs conséquences respectives!
                </strong>
            </p>
            <h2>
                <strong>
                    Qu’est-ce que la conduite dangereuse et quelles sont les
                    conséquences d’une condamnation ?
                </strong>
            </h2>
            <p>
                La <strong>conduite dangereuse</strong> est une infraction
                criminelle qui se produit lorsqu’un individu manœuvre un
                véhicule de manière imprudente ou négligente, mettant ainsi en
                danger la sécurité du public.
            </p>
            <p>
                L’article{' '}
                <Link to="https://laws-lois.justice.gc.ca/fra/lois/c-46/section-320.13.html">
                    320.13 (1)
                </Link>{' '}
                du Code criminel définit cette infraction comme suit :
            </p>
            <p>
                « Commet une infraction quiconque conduit un moyen de transport
                d’une façon dangereuse pour le public, eu égard aux
                circonstances. »
            </p>
            <p>
                Les tribunaux examinent non seulement les manœuvres du
                conducteur, mais aussi le contexte, notamment:
            </p>
            <ul>
                <li>L’état de la route</li>
                <li>Les conditions météorologiques</li>
                <li>La densité de la circulation sur la route</li>
                <li>L’environnement et le lieu de l’infraction</li>
            </ul>
            <p>
                Contrairement à d’autres infractions liées à la conduite (comme
                la conduite avec facultés affaiblies), la conduite dangereuse ne
                requiert pas une consommation d’alcool et/ou drogue.{' '}
            </p>
            <h3>
                <strong>Il existe trois degrés de conduite dangereuse!</strong>
            </h3>
            <p>
                Selon les conséquences qu’elle entraîne, la conduite dangereuse
                est classée en trois degrés d’infraction dans le Code criminel.
            </p>
            <h4>
                <strong>1) Conduite dangereuse simple</strong>
            </h4>
            <p>
                Ce niveau représente la forme la plus légère de conduite
                dangereuse, où il n'y a ni blessure ni décès impliqué. Cette
                infraction peut être traitée par deux modes de poursuite ayant
                chacune ses peines maximales :
            </p>
            <ul>
                <li>Acte criminel ( maximal de dix ans).</li>
                <li>
                    Procédure sommaire (emprisonnement maximal de deux ans moins
                    un jour).
                </li>
            </ul>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Il existe trois degrés de conduite dangereuse!"
                    alt=""
                />
            </p>
            <p>
                La décision de poursuivre par acte criminel ou par procédure
                sommaire appartient au procureur de la Couronne, qui se basera
                sur la gravité des faits, les antécédents de la personne accusée
                et la politique de poursuite du ministère public.
            </p>
            <h4>
                <strong>
                    2) Conduite dangereuse causant des lésions corporelles{' '}
                </strong>
            </h4>
            <p>
                Ce second degré implique que la conduite dangereuse a provoqué
                des lésions corporelles à une autre personne.
            </p>
            <ul>
                <li>
                    Les lésions corporelles sont des « blessures qui nuit à la
                    santé ou au bien-être d’une personne et qui ne sont pas de
                    nature passagère ou sans importance. » 
                </li>
                <li>
                    La peine encourue pour ce type de conduite dangereuse est
                    naturellement plus sévère, car elle reflète les conséquences
                    physiques subies par les victimes:Une poursuite par acte
                    criminel peut entraîner une peine maximale de 14 ans
                    d’emprisonnement.
                </li>
                <li>
                    Une amende obligatoire minimale de 1 000 $pour une première
                    infraction.
                </li>
                <li>
                    Une poursuite par procédure sommaire entraîne une peine
                    maximale de deux ans moins un jour d’emprisonnement et une
                    amende maximale de 5 000 $. Il est important de noter que
                    l’amende minimale de 1 000 $ s’applique même en cas de
                    procédure sommaire.
                </li>
            </ul>
            <p>
                Tout comme pour l’infraction de conduite dangereuse simple, le
                choix entre une poursuite par acte criminel ou par procédure
                sommaire pour cette infraction dépend des circonstances,
                notamment de la gravité des faits et des antécédents de la
                personne accusée.
            </p>
            <h4>
                <strong>3) Conduite dangereuse causant la mort </strong>
            </h4>
            <p>
                La forme la plus grave de conduite dangereuse est celle où cette
                conduite entraîne le décès d’une autre personne.
            </p>
            <ul>
                <li>
                    Un acte criminel passible d’un emprisonnement à perpétuité.
                </li>
                <li>Une amende minimale obligatoire de 1 000 $.</li>
            </ul>
            <p>
                La peine déterminée par le tribunal pour une conduite dangereuse
                ayant causé la mort varie selon plusieurs facteurs aggravants ou
                atténuants (antécédents du conducteur, circonstances du décès,
                degré de négligence, etc.).
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            Peu importe le type de conduite dangereuse, une
                            personne reconnue coupable verra l’infraction
                            inscrite à son casier judiciaire.
                        </p>
                    </td>
                </tr>
            </table>

            <h3>
                <strong>
                    L’interdiction de conduire : peine additionnelle pour la
                    conduite dangereuse!
                </strong>
            </h3>
            <p>
                En plus d’une peine de prison ou d’une amende, le tribunal peut
                aussi imposer une interdiction de conduire. Contrairement à
                l’infraction de conduite avec facultés affaiblies, où cette
                interdiction est obligatoire, elle est discrétionnaire dans les
                cas de conduite dangereuse.
            </p>
            <h4>
                <strong>
                    Qu’est-ce qu’une ordonnance d’interdiction de conduire ?
                </strong>
            </h4>
            <p>
                Il s'agit d'une mesure visant à interdire à une personne
                condamnée de conduire tout véhicule à moteur au Canada pendant
                une période déterminée.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Ordonnance d’interdiction de conduire!"
                    alt=""
                />
            </p>
            <p>
                Le juge peut la prononcer lorsqu’il estime que la personne
                représente un risque pour la sécurité routière. Le tribunal
                prend en considération la gravité des faits, le comportement du
                conducteur, son dossier de conduite ainsi que les conséquences
                de l’infraction.
            </p>
            <h4>
                <strong>
                    Quelle est la durée de l’interdiction de conduire ?
                </strong>
            </h4>
            <p>
                Il n’y a pas de durée minimale prévue par la loi, mais la durée
                maximale de l’interdiction dépend du type d’infraction commise
                et de la peine d’emprisonnement applicable. Voici les trois
                catégories :
            </p>
            <table>
                <tr>
                    <td>
                        <p>Catégorie d’infraction</p>
                    </td>
                    <td>
                        <p>Durée maximale de l’interdiction de conduire</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Infraction passible d’emprisonnement à perpétuité</p>
                    </td>
                    <td>
                        <p>
                            Durée laissée à la discrétion du juge, sans limite
                            maximale
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>
                            Infraction passible d’emprisonnement supérieure à 5
                            ans, mais inférieure à la perpétuité.
                        </p>
                    </td>
                    <td>
                        <p>
                            Jusqu’à 10 ans, en plus de la peine d’emprisonnement
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Tous les autres cas</p>
                    </td>
                    <td>
                        <p>
                            Jusqu’à 3 ans, en plus de la peine d’emprisonnement
                        </p>
                    </td>
                </tr>
            </table>
            <h4></h4>
            <h4>
                <strong>
                    Formalités autour de l’ordonnance d’interdiction
                </strong>
            </h4>
            <p>
                Le Code criminel exige que la personne condamnée soit clairement
                informée de l’ordonnance d’interdiction de conduire prononcée
                contre elle. Cette information peut être transmise soit par la
                lecture de l’ordonnance par le juge, soit par la remise d’une
                copie à l’accusé.
            </p>
            <p>
                Même si l’ordonnance n’est ni lue ni remise, elle demeure valide
                et exécutoire! Toutefois, en cas d’accusation pour non-respect
                de l’interdiction, l’accusé pourrait invoquer en défense le fait
                qu’il n’a pas été informé de celle-ci, ce qui pourrait
                influencer l’issue du procès.
            </p>
            <h2>
                <strong>
                    Qu’est-ce que la conduite avec facultés affaiblies par
                    l’alcool et quelles sont les conséquences d’une condamnation
                    ?
                </strong>
            </h2>
            <p>
                L’infraction de conduite avec les facultés affaiblies par
                l’alcool, encadrée par l’article{' '}
                <Link to="https://laws-lois.justice.gc.ca/fra/lois/c-46/section-320.14.html">
                    320.14
                </Link>{' '}
                du Code criminel, peut être établie dans deux situations
                distinctes.
            </p>
            <ul>
                <li>
                    La première situation se produit lorsqu’une personne prend
                    le volant alors que sa capacité de conduire est affaiblie
                    par l’alcool, des drogues ou une combinaison des deux.
                </li>
            </ul>
            <p>
                Il n’est pas nécessaire d’obtenir un résultat précis à un test
                pour que cette infraction soit retenue. Des signes clairs
                d’affaiblissement, comme une mauvaise coordination, une
                élocution ralentie ou un comportement inhabituel, peuvent
                suffire à établir l’altération des facultés.
            </p>
            <ul>
                <li>
                    La deuxième situation repose sur une preuve d’alcoolémie
                    claire. Si une analyse effectuée dans les deux heures
                    suivant la conduite révèle un taux d’alcool dans le sang
                    égal ou supérieur à 80 milligrammes par 100 millilitres, la
                    personne est en infraction, peu importe son comportement
                    observé au moment de l’arrestation.
                </li>
            </ul>
            <p>
                Toutefois, une personne n’est pas en infraction si elle a
                consommé uniquement après avoir cessé de conduire!
            </p>
            <h3>
                <strong>Sanctions applicables en cas de condamnation:</strong>
            </h3>
            <p>
                Être déclaré coupable de conduite avec les facultés affaiblies
                par l’alcool entraîne une série de conséquences sérieuses, tant
                immédiates qu’à long terme.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Sanctions liées à une condamnation pour alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Voici un aperçu des sanctions prévues en cas de première
                    condamnation pour conduite avec les facultés affaiblies par
                    l’alcool :
                </strong>
            </p>
            <ul>
                <li>
                    <strong>Révocation du permis : </strong>Après la déclaration
                    de culpabilité, le permis de conduire est révoqué pour une
                    période minimale d’un an.{' '}
                </li>
                <li>
                    <strong>Peine d’emprisonnement : </strong>Selon la gravité
                    de l’affaire, le juge peut prononcer une peine pouvant
                    atteindre 10 ans d’incarcération.
                </li>
                <li>
                    <strong>Casier judiciaire : </strong>Toute condamnation
                    entraîne automatiquement l’inscription de l’infraction au
                    casier judiciaire, ce qui peut avoir des répercussions
                    importantes sur l’emploi, les voyages ou d’autres aspects de
                    la vie courante. Une{' '}
                    <Link to="https://avocatsalcoolauvolant.ca/obtenir-pardon-alcool-volant-quebec/">
                        demande de pardon pour un casier judiciaire
                    </Link>{' '}
                    peut être faite plusieurs années après la condamnation.
                </li>
                <li>
                    <strong>
                        Installation d’un antidémarreur éthylométrique :{' '}
                    </strong>
                    Le tribunal peut exiger l’installation de cet appareil qui
                    empêche le véhicule de démarrer si de l’alcool est détecté
                    dans l’haleine du conducteur.{' '}
                    <strong>Amende obligatoire :</strong> Le montant de l’amende
                    varie en fonction du taux d’alcoolémie :
                    <ul>
                        <li>
                            <ul>
                                <li>
                                    Taux entre 80 et 119 mg par 100 ml de sang :
                                    1 000 $
                                </li>
                                <li>Taux entre 120 et 159 mg : 1 500 $</li>
                                <li>
                                    Taux de 160 mg et plus ou refus de passer un
                                    test : 2 000 $
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Programmes de réhabilitation :</strong> Le
                    contrevenant devra souvent suivre des programmes comme
                    Alcofrein, qui visent à évaluer le risque de récidive et à
                    sensibiliser les conducteurs aux dangers de la conduite avec
                    facultés affaiblies.
                </li>
            </ul>
            <h4>
                <strong>Que se passe-t-il en cas de récidive ?</strong>
            </h4>
            <p>
                Si une personne est reconnue coupable une{' '}
                <Link to="https://avocatsalcoolauvolant.ca/alcool-volant-deuxieme-infraction/">
                    deuxième fois
                </Link>{' '}
                de l’infraction de conduite avec les facultés affaiblies dans un
                délai de 10 ans, les conséquences sont encore plus lourdes. Une
                peine minimale d’emprisonnement de 30 jours est imposée, une
                révocation prolongée du permis de conduire est prévue, en plus
                de plusieurs autres sanctions importantes.
            </p>
            <p>
                Il en va de même pour une{' '}
                <Link to="https://avocatsalcoolauvolant.ca/troisieme-infraction-alcool-volant/">
                    troisième condamnation
                </Link>{' '}
                dans un délai de 10 ans, où les peines deviennent
                particulièrement sévères.
            </p>
            <p>
                Elles comprennent une{' '}
                <strong>
                    peine minimale d’emprisonnement obligatoire de 120 jours
                </strong>
                , ainsi que l’interdiction d’immatriculer, d’acquérir, de louer
                ou de mettre en circulation un véhicule à son nom, ainsi que
                l’installation à vie d’un antidémarreur éthylométrique
            </p>
            <h2>
                <strong>
                    Que se passe-t-il lorsqu’une personne est condamnée en même
                    temps pour conduite dangereuse et facultés affaiblies?
                </strong>
            </h2>
            <p>
                Lorsqu’une personne est reconnue coupable à la fois de conduite
                dangereuse et de conduite avec les facultés affaiblies par
                l’alcool pour un seul et même événement, il convient de se
                demander quelles sont les sanctions et les peines qui
                s’appliquent!
            </p>
            <p>
                <Img
                    fluid={data.img4.childImageSharp.fluid}
                    title="Condamnation pour alcool au volant et conduite dangereuse!"
                    alt=""
                />
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            Exemple:Un conducteur roule à 120 kilomètres à
                            l’heure dans une zone scolaire en pleine journée
                            alors que ses facultés sont affaiblies par l’effet
                            de l’alcool. Pour ce même événement, il peut être
                            accusé à la fois de conduite dangereuse et de
                            conduite avec les facultés affaiblies par l’alcool.
                        </p>
                    </td>
                </tr>
            </table>

            <h3>
                <strong>
                    Est-ce qu’on additionne les peines d’emprisonnement des deux
                    infractions?
                </strong>
            </h3>
            <p>
                Non. Il n’y a pas de peine cumulative au Canada pour des
                infractions découlant d’un même événement. Contrairement à
                certains pays comme les États-Unis, où les peines peuvent
                s’additionner, le système canadien prévoit généralement des
                peines concurrentes lorsqu’une personne est reconnue coupable de
                plusieurs infractions liées à un seul évènement.
            </p>
            <p>
                Cela signifie que les peines imposées pour chaque infraction
                sont purgées en même temps!Le tribunal peut exceptionnellement
                imposer des peines consécutives (l’une après l’autre), mais
                seulement lorsque les infractions découlent de faits distincts.
                Ce ne serait{' '}
                <strong>
                    pas le cas si les deux accusations sont issues du même
                    événement.
                </strong>
                Lorsqu’une personne est accusée de conduite dangereuse et de
                conduite avec les facultés affaiblies pour un même événement,
                elle purge une seule peine effective, correspondant à la plus
                sévère des deux. De même,{' '}
                <strong>
                    les sanctions administratives, comme la révocation du permis
                    de conduire, sont appliquées une seule fois
                </strong>
                .
            </p>
            <h2>
                <strong>
                    Vous avez été arrêté pour conduite dangereuse et alcool au
                    volant? Consultez un avocat spécialisé en droit criminel !
                </strong>
            </h2>
            <p>
                Si vous faites face à des accusations de conduite avec les
                facultés affaiblies par l’alcool et de conduite dangereuse pour
                le même événement, il est crucial de consulter rapidement un
                avocat spécialisé en droit criminel.
            </p>
            <p>
                Ne sous-estimez jamais l’importance d’engager un avocat
                spécialisé en droit criminel lorsque vous êtes confronté à des
                lourdes accusations criminelles, son intervention peut faire
                toute la différence dans le déroulement et le résultat de votre
                procès.
            </p>
            <p>
                <Img
                    fluid={data.img5.childImageSharp.fluid}
                    title="Avocat pour alcool au volant et conduite dangereuse!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Remplissez notre formulaire rapide et gratuit pour trouver
                    facilement un avocat spécialisé en droit criminel.
                </strong>
            </p>
            <p>
                <strong>
                    Dès votre demande reçue, nous vous mettons en contact
                    rapidement avec un avocat qualifié près de chez vous. Ce
                    service est entièrement gratuit et sans engagement !
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "conduite-dangereuse-alcool-volant-sanctions/conduite-dangereuse-infraction-criminelle.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "conduite-dangereuse-alcool-volant-sanctions/trois-degres-conduite-dangereuse-canada.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "conduite-dangereuse-alcool-volant-sanctions/ordonnance-interdiction-conduire-conduite-dangereuse.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "conduite-dangereuse-alcool-volant-sanctions/sanctions-condamnation-alcool-volant-quebec.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img4: file(
            relativePath: {
                eq: "conduite-dangereuse-alcool-volant-sanctions/condamnation-alcool-volant-conduite-dangereuse.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img5: file(
            relativePath: {
                eq: "conduite-dangereuse-alcool-volant-sanctions/avocat-alcool-volant-conduite-dangereuse.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
